export default __webpack_public_path__ + "static/media/thunder-alt.f80c5cd4.svg";